import React from 'react';
import { Link } from 'react-router';

import styles from '../css/Main.css';

export default function Navigation() {
  return (
    <div className={styles.parent}>
      <div className={styles.children}>
        <Link className={styles.link} to="home">Home</Link>
      </div>
      <div className={styles.children}>
        <Link className={styles.link} to="arbeiten">Arbeiten</Link>
      </div>
      <div className={styles.children}>
        <Link className={styles.link} to="veröffentlichungen">Veröffentlichungen</Link>
      </div>
      <div className={styles.children}>
        <Link className={styles.link} to="kontaktAktuell">Kontakt/Aktuell</Link>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js